import MainLayout from "../components/SharedComponents/MainLayout";
import PrivacyPolicy from "../components/PrivacyPolicyComponents/PrivacyPolicy";

export default function PrivacyPolicyPage() {
    return (
      <div>
        <MainLayout>
          <PrivacyPolicy />
        </MainLayout>
      </div>
    );
  }
  
